import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ZippyEventType, subject } from '@df/legacy/ui/zippy/zippy.abstract';
import { ZippyModule } from '@df/legacy/ui/zippy/zippy.module';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import SwiperCore, { A11y, EffectFade, FreeMode, Swiper } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { SwiperEvents } from 'swiper/types';
import { FashionRecommendationsColourComponent } from './colour/fashion-recommendations-colour.component';
import { FASHION_RECOMMENDATIONS_COMPONENT_CONFIG } from './fashion-recommendations.config';
import { IFashionRecommendationsBlockData } from './fashion-recommendations.interface';
import { FashionRecommendationsSlideComponent } from './slide/fashion-recommendations-slide.component';
// install Swiper modules
SwiperCore.use([A11y, EffectFade, FreeMode]);
@Component({
    selector: 'fashion-recommendations',
    templateUrl: 'fashion-recommendations.component.html',
    styleUrls: ['fashion-recommendations.component.scss'],
    standalone: true,
    imports: [
        FashionRecommendationsColourComponent,
        FashionRecommendationsSlideComponent,
        ICmsClientModule,
        SizeClassDirective,
        SwiperModule,
        TranslationModule,
        ZippyModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentFashionRecommendationsComponent>(FASHION_RECOMMENDATIONS_COMPONENT_CONFIG)
export class PageComponentFashionRecommendationsComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IFashionRecommendationsBlockData;
    swiper?: Swiper;
    currentIndex: number = 0;
    select(index: number): void {
        this.currentIndex = index;
        this.swiper?.slideTo(index);
        subject.next({
            type: ZippyEventType.open,
            id: {
                name: 'carousel',
                group: 'fashion-recommendations',
                isGroup: false
            }
        });
        this.detectChanges();
    }
    onAfterInit(eventParams: Parameters<SwiperEvents['afterInit']>) {
        const [swiper] = eventParams;
        this.swiper = swiper;
        this.detectChanges();
    }
}
